var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('div',{staticClass:"spinner w-100"}):_vm._e(),_c('Chart',{ref:"chart",attrs:{"options":_vm.chartOptions,"series":_vm.series,"height":"800","type":"line"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }